import axios from 'axios';
import { registry } from 'tsyringe';

export const kDITokenAxios = 'vendor-axios';

// -----------------------------------------------------------------------------
// Register vendor classes - like axios. Useful for testing, as it allows us to
// perform e2e tests without injecting any substitution classes of our own code.
@registry([
  // ---------------------------------------------------------------------------
  {
    token: kDITokenAxios,
    useValue: axios,
  },
])
export class VendorRegistry {}
